import {PrivacyPolicyPage as PrivacyPolicy} from './PrivacyPolicy';
export default PrivacyPolicy;
